<template>
    <v-container fluid class="mt-8">
        <v-row
        align="center"
        justify="center"
        >
           <v-card
                class="mx-auto"
                min-width="344"
                max-width="344"
                shaped
                elevation="12"
            >
                <v-img
                    alt="partyLlamada"
                    class="ml-auto mr-auto mt-4 center"
                    style="border-radius: 8px;"
                    :src="require('../assets/partyLlamada.png')"
                    transition="scale-transition"
                    width="100"
                />

                <v-col cols="12" class="text-center title mb-0 pb-0">
                    partyLlamada
                </v-col>

                <v-card-subtitle class="text-center pt-0 mt-0 font-weight-bold" >
                    Juega gratis con familiares y amigos a través de nuestro videochat
                </v-card-subtitle>

                <v-card-text class="font-weight-light">
                    ¡Describe palabras, haz mímica, canta canciones y mucho más! Juega con familiares y amigos a través del videochat. ¡CUIDADO! Con este juego es fácil ganarse enemigos :P
                </v-card-text>

                <!-- <v-divider></v-divider>
                <v-card-subtitle class="text-center mb-1 pb-0" >
                    Android estará próximamente
                </v-card-subtitle> -->
                <v-img
                    alt="partyLlamada"
                    class="ml-auto mr-auto mt-0 pt-0 center"
                    style="border-radius: 8px;"
                    :src="require('../assets/appstore@2x.png')"
                    transition="scale-transition"
                    width="30%"
                />

                <v-card-actions>
                    <v-btn
                        color="purple"
                        text
                        @click="show = !show"
                    >
                        Ver categorías
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        icon
                        @click="show = !show"
                    >
                        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-expand-transition>
                    <div v-show="show">
                        <v-divider></v-divider>

                        <v-card-text>
                            <ul 
                            v-for="category in categories"
                            :key="category">
                                <li>{{category}}</li>
                            </ul>
                        </v-card-text>
                    </div>
                </v-expand-transition>
                <v-card-actions>
                    <v-btn
                        text
                        @click="goToPrivacy"
                    >
                        <span class="caption font-weight-thin">Ver Política de privacidad</span>
                    </v-btn>

                </v-card-actions>

                
            </v-card>
        </v-row>
    </v-container>
</template>

<script lang="javascript" src="FileSaver.min.js"></script>
<script>
import * as moment from 'moment';
import {mapGetters} from 'vuex' 

export default {
    name: "Home",
    data: function() {
        return {
            show: false,
            categories: ["Series", "Marcas", "Bebidas alcohólicas", "Profesiones", "Verbos", "Actores y actrices", "Animales", "Cantantes", "Capitales", "Deportes", "Frutas y verduras", "Juegos de mesa", "Países", "Películas", "Personajes influyentes", "Cantates españoles", "Jugadores de fútbol"]
        }
    },
    mounted () {
        
    },
    methods: {
        goToPrivacy() {
            this.$router.push("./privacy")
        }
    }
}
</script>
